import rdvsFromPlage from "./rdvsFromPlage.js";
import availableTime from "./availableTime.js";
import sliceDurees from "./sliceDurees.js";
import { Transforms } from "../../index.js";
import relevantHoraire from "../horaires/relevantHoraire.js";
import getPlageFromHM from "../horaires/getPlageFromHM.js";
//on peut fournir un rdv optionnel qui correspond au rdv en cours d'édition dans le cas d'un editrdv
const getDurees = (allHoraires, allRdvs, dateProposed, hmProposed, dureeMiniRdv, rdv) => {
    "use strict";
    const horaire = relevantHoraire(allHoraires, dateProposed);
    if (!horaire) {
        return [];
    }
    const bornes = Transforms.horaires.bornesForDay(horaire, dateProposed);
    if (!bornes) {
        return [];
    }
    const plage = getPlageFromHM(hmProposed, bornes);
    const dayRdvs = allRdvs.filter((r) => r.date.getTime() === dateProposed.getTime());
    if (!plage) {
        return [];
    }
    const plageRdvs = rdvsFromPlage(dayRdvs, plage);
    const time = availableTime(hmProposed, plageRdvs, plage, rdv);
    return sliceDurees(time, dureeMiniRdv);
};
const getDurees2 = (horaire, allRdvs, dateProposed, hmProposed, dureeMiniRdv, rdv) => {
    const bornes = Transforms.horaires.bornesForDay(horaire, dateProposed);
    if (!bornes) {
        return [];
    }
    const plage = getPlageFromHM(hmProposed, bornes);
    const dayRdvs = allRdvs.filter((r) => r.date.getTime() === dateProposed.getTime());
    if (!plage) {
        return [];
    }
    const plageRdvs = rdvsFromPlage(dayRdvs, plage);
    const time = availableTime(hmProposed, plageRdvs, plage, rdv);
    return sliceDurees(time, dureeMiniRdv);
};
export default getDurees;
export { getDurees2 };
//# sourceMappingURL=getDurees.js.map